// @ts-nocheck

import { colors } from '@lmc/common/constants'
import { Button, Icon } from '@lmc/ui-kit'
import { get } from 'lodash'
import { PureComponent } from 'react'
import { FormFieldLayout } from '../../generic'
export default class FileUploadField extends PureComponent {
  hiddenFileInput = null

  setHiddenFileInput = (node) => (this.hiddenFileInput = node)

  triggerFileInput = () => this.hiddenFileInput.click()

  handleFileSelect = (e) => {
    const { formKey, onChange } = this.props
    if (!e.target.files || !e.target.files.length) return null

    const file = e.target.files[0]
    const uri = URL.createObjectURL(file)

    onChange({ key: formKey, file, uri })
  }

  formatFileName = (fileName) => {
    if (fileName.length > 30) {
      return `${fileName.slice(0, 13)} ... ${fileName.slice(-12)}`
    }
    return fileName
  }

  render() {
    const {
      errors,
      formKey,
      inputType,
      onChange,
      className,
      placeholder,
      style,
      values,
      ...props
    } = this.props

    const error = get(errors, formKey)
    const value = get(values, formKey)

    return (
      <FormFieldLayout hasErrors={!!error} {...props}>
        <div style={{ ...style, ...styles.wrapper }}>
          <Button
            glyph="cloud-upload"
            onClick={this.triggerFileInput}
            style={styles.button}
            variant="default"
            icon={<Icon type="CloudUploadOutlined" />}
          >
            {value ? 'Change file' : 'Upload file'}
          </Button>
          {value && value.file && (
            <span style={styles.fileName}>
              {this.formatFileName(value.file.name)}
            </span>
          )}
          <input
            accept=".pdf,.png,.jpg,.jpeg,.heic,.docm,.gif,.docx,.doc,.xlsx,.xls,.txt,.csv,.ppt,.pptx"
            ref={this.setHiddenFileInput}
            type="file"
            onChange={this.handleFileSelect}
            style={styles.hiddenFileInput}
          />
        </div>
      </FormFieldLayout>
    )
  }
}

const styles = {
  button: {
    marginRight: 12
  },
  fileName: {
    color: colors.darkgrey
  },
  hiddenFileInput: {
    left: -9999,
    position: 'absolute'
  },
  wrapper: {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap'
  }
}
